module.exports = __webpack_public_path__ + "c48a3083595c0ae20a8dd6e6d11107b3.pdf";